import { render } from "./WebVersionInfoR.vue?vue&type=template&id=6f0fee97"
import script from "./WebVersionInfoR.vue?vue&type=script&lang=js"
export * from "./WebVersionInfoR.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__